import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as PropertyComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import * as ANT from 'antd';
import DEFINE, { FEATURE_FLAGS, TRANSLATE_LANGUAGE } from "../../../../constants/Define";
import { FlagIcons } from '../../common/component/TranslateButton';
import { toArray } from 'lodash';
import EllipsisText from '../../common/component/EllipsisText';

let permisionActions = [];
class Properties extends Component {

    state = {
        titleTable: Func.getTitleTable(Model.PropertiesModel.titleTable, ['action'], ['id']),
        modelProperty: Model.PropertiesModel.titleTable,
        componentTable: {
            name: {
                sorter: (i, k) => i.name.length - k.length,
                key: 'name',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            email: {
                key: 'email',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            phone: {
                key: 'phone',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            address: {
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            translations: {
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
                render: (text, record) => <FlagIcons languages={record.translations} />,
                width: 120,
            },
            action: {
                align: 'center',
                width: 100,
                render: (text, record) => <PropertyComponent.EditComponent item={record} permisionActions={permisionActions}
                    onDeleteProperty={this.props.onDeleteProperty} />,
            }
        },
        properties: [],
        pageSize: this.props.properties.data.pageSize,
        pageIndex: this.props.properties.data.pageIndex,
        totalCount: this.props.properties.data.totalCount,
        totalPage: this.props.properties.data.totalPage,
        isFetching: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PROPERTY);
        this.setState({
            pageSize: this.props.properties.data.pageSize,
            pageIndex: this.props.properties.data.pageIndex,
            totalCount: this.props.properties.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.properties.data.totalCount) / parseInt(this.props.properties.data.pageSize))
        })
        this.props.onListProperty({ pageSize: this.props.properties.data.pageSize, pageIndex: this.props.properties.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.properties.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.properties.data !== prevProps.properties.data) {
            this.setState({
                properties: this.props.properties.data.result,
                pageSize: this.props.properties.data.pageSize,
                pageIndex: this.props.properties.data.pageIndex,
                totalCount: this.props.properties.data.totalCount,
                totalPage: this.props.properties.data.totalCount / this.props.properties.data.pageSize,
            })
        }
    }

    onChangeLanguage = (language) => {
        this.props.onListProperty({ pageSize: this.props.properties.data.pageSize, pageIndex: this.props.properties.data.pageIndex });
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListProperty(newFilters);

    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, properties, modelProperty, isFetching, totalCount, componentTable, pageIndex, pageSize } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath="properties"
                        titleHeader={t('navigation.properties')}
                        componentRight={
                            <Fragment> {
                                permisionActions && permisionActions.allowCreate &&
                                <Link to="/properties/action"
                                    className='btn btn-primary'> + {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="property-list"
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(properties, modelProperty)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'property'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, current: pageIndex, pageSize }}
                        componentTableList={{
                            // right: <Fragment> {
                            //     permisionActions && permisionActions.allowCreate &&
                            //     <Link to="/properties/action"
                            //         className='btn btn-primary'> + {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                        classChildren="p-0" classParent="m-0"
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        properties: state.propertyReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListProperty: (filters) => {
            dispatch(action.dataPropertyAction(filters))
        },
        onDeleteProperty: (id) => {
            dispatch(action.deletePropertyAction(id))
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Properties));
